import MainForm from "./MainForm";
import CalendarEventsForm from "./CalendarEventsForm";

export default { MainForm, CalendarEventsForm };
